<template>
  <v-btn
    :rounded="rounded"
    class="innova-btn"
    :class="[colorClass]"
    :small="size === 'small'"
    @click="throttledClickHandler"
    :disabled="disabled || isThrottleDisabled"
    :block="block"
  >
    <div class="d-flex align-center justify-center">
      <v-icon v-if="prependIcon" class="mr-1">
        {{ prependIcon }}
      </v-icon>
      <v-icon v-if="icon">
        {{ icon }}
      </v-icon>
      <slot v-else></slot>
      <v-icon v-if="appendIcon" class="ml-1">
        {{ appendIcon }}
      </v-icon>
    </div>
  </v-btn>
</template>

<script>
const COLOR_CLASSES = {
  primary: 'innova-blue',
  blue: 'innova-blue',
  success: 'innova-green',
  green: 'innova-green',
  danger: 'innova-red',
  red: 'innova-red',
  warning: 'innova-yellow',
  yellow: 'innova-yellow',
  grey: 'innova-grey'
};

export default {
  name: 'InnovaButton',
  props: {
    rounded: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
      validator(value) {
        return !!COLOR_CLASSES[value];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    throttleTime: {
      type: Number,
      default: 0,
    },
    disableOnThrottle: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'medium',
    },
    prependIcon: {
      type: String,
    },
    appendIcon: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
  data() {
    return {
      throttleTimeout: null,
      isThrottling: false,
    };
  },
  computed: {
    colorClass() {
      return COLOR_CLASSES[this.color] || COLOR_CLASSES.primary;
    },
    isThrottleDisabled() {
      return this.disableOnThrottle && this.isThrottling;
    },
  },
  methods: {
    // Custom throttle function: returns a throttled version of the callback
    throttle(func, limit) {
      let inThrottle = false;
      return (...args) => {
        if (!inThrottle) {
          func.apply(this, args);
          inThrottle = true;
          this.isThrottling = true;
          this.throttleTimeout = setTimeout(() => {
            inThrottle = false;
            this.isThrottling = false;
            this.throttleTimeout = null;
          }, limit);
        }
      };
    },

    onClickHandler(ev) {
      this.$emit('click', ev);
    },
  },
  created() {
    // Create throttled click handler only if throttleTime > 0, else use direct handler
    if (this.throttleTime > 0) {
      this.throttledClickHandler = this.throttle(this.onClickHandler, this.throttleTime);
    } else {
      this.throttledClickHandler = this.onClickHandler;
    }
  },
  beforeDestroy() {
    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout);
      this.throttleTimeout = null;
    }
  },
};
</script>

<style scoped>
.innova-btn i {
  color: white !important;
}

.innova-btn.innova-blue {
  background-color: #3498db;
  color: white;
}

.innova-btn.innova-green {
  background-color: #00a178;
  color: white;
}

.innova-btn.innova-yellow {
  background-color: #f29d35;
  color: white;
}

.innova-btn.innova-red {
  background-color: #f44336;
  color: white;
}

.innova-btn.innova-grey {
  background-color: #616161;
  color: white;
}
</style>
